import { sdkError } from "./log";
import type { AdClickedCallback } from "./types";

const ALLOWED_ORIGINS = [
  "https://www.google.com",
  "https://www.adsensecustomsearchads.com",
  "https://syndicatedsearch.goog",
  "https://googleadservices.com",
];

const MESSAGE_PREFIX = "FSXDC,.aCS:";

/**
 * Use this to test in adtest mode:
 * ((a)=>a&&(a.target="_blank",a.rel="noopener",a.click()))(document.querySelector('a[href*="syndicatedsearch.goog/aclk"]'))
 */
export const wireAdClickListener =
  (activeAdClickedCallback: AdClickedCallback) => (event: MessageEvent) => {
    // Validate origin
    if (!ALLOWED_ORIGINS.includes(event.origin)) {
      return;
    }

    if (
      typeof event.data !== "string" ||
      !event.data.startsWith(MESSAGE_PREFIX)
    ) {
      return;
    }
    try {
      activeAdClickedCallback();
    } catch (e) {
      sdkError(e);
    }
  };
